/* eslint-disable */
import Vue from 'vue'

export const Bus = new Vue()

export default Vue => {
    const bus = Bus
    Vue.bus = bus
    Vue.prototype.$bus = bus
}


// WEBPACK FOOTER //
// ./src/global/bus.js